export const featureList = [
    "Comprehensive Suite of Project Management Tools For Managing Assets",
    "Unlimited Storage & Organization For All File Types",
    "Fully Tailored Platform Aligned With Your Brand Identity",
    "Organize Projects With Restricted Access To Essential Items",
    "Isolated Sandbox For Safe Creative Collaboration",
    "Streamlined Processes To Boost Productivity For Your Artists",
    "Advanced Protection For Your Intellectual Property",
];

export const majorPlanFeatures = [
    "Upload and store up to 1TB of music files and stems",
    "Have your music highlighted at the top of our 'Featured Section'",
    "Shoutout in our emails and on social media to tens of thousands of users",
    "Inner circle access to select musicians and producers in our network",
    "Priority access to our newest creative music tools before they launch",
];

export const minorPlanFeatures = [
    "Upload & store up to 500GB of high-quality audio and project files",
    "Advanced AI-based music organization with smart tags and sorting",
    "Share tracks publicly or privately with full permission control",
    "Profile & music featured at the top of the Explore page for exposure",
    "Eligible for Featured Artist Spotlights on homepage & Explore",
    "Social media & newsletter promotion for select tracks",
    "FREE Dolby.io AI mastering (up to X tracks/month – TBD)",
    "Unlimited encrypted messaging with collaborators and fans",
    "Project management tools: timelines, versioning & task tracking",
    "Distribute music to Spotify, Apple Music & more (Coming Soon)",
    "Manage your earnings in the Revenue & Royalties Dashboard (Coming Soon)",
];

export const freePlanFeatures = [
    "Upload & store up to 5GB of music files, stems, and project files",
    "Basic AI-based music organization for easy cataloging",
    "Share tracks publicly or privately with full access control",
    "Profile & music featured on the Explore page for visibility",
    "Unlimited encrypted messaging with other OmMuse users",
    "Version control: update tracks and stems with collaborators",
    "Access Dolby.io AI mastering at full price ($4.99/track)",
    "Discover and collaborate with other artists through our user network",
    "Revenue dashboard & distribution to DSPs like Spotify (Coming Soon)",
];

export const studioPlanFeatures = [
    "1TB of Optimized Music & File Storage",
    "Advanced AI-Based Music Organization",
    "Tracks & NFTs Added to 'Featured Section'",
    "Profile, Tracks, & NFTs Highlighted on Website",
    "Social Media Promotion on OmMuse Socials",
    "Discounted Dolby.io AI Mastering ($4.99/track)",
    "Discounted Smart Contract Minting ($9.99/track)",
    "Shoutout on OmMuse Social Media Channels",
];

export const openMailToLink = (): void => {
    const mailtoLink = `mailto:hello@ommuse.com`;
    const newTab = window.open(mailtoLink);

    if (newTab && typeof newTab.focus === "function") {
        newTab.focus();
    } else {
        window.location.href = mailtoLink;
    }
};
